export enum CHIP_BACKGROUND_COLORS {
  UPLOADED = '#00990f',
  FAILED = '#e30f0f',
  UPLOADING = '#0085e5',
  PENDING_UPLOAD = '#ffa500',
  PENDING_DELETE = '#666666',
  APPROVED = '#28a745',
  REJECTED = '#dc3545',
  RETURNED = '#ff9800',
}
